<template>
	<div>

		<router-view/>
	</div>
</template>

<script>
    export default {
        name: 'receipt',
        data () {
            return {
                msg: ''
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/receipt.vue